import type { AGGError } from '@atlassian/jira-relay-errors/src/index.tsx';

export class RelayAGGError extends Error {
	public name: string;

	public graphQLError: AGGError;

	public statusCode?: number;

	public message: string;

	constructor(error: AGGError) {
		super();

		this.graphQLError = error;
		this.statusCode = error.extensions?.statusCode ?? undefined;
		this.message = error.message;
		this.name = 'AGGError';
	}
}

export const getFirstAGGError = (error: Error): RelayAGGError | null => {
	if (!('source' in error)) {
		return null;
	}

	const errorSource = error.source;
	const errors =
		errorSource && typeof errorSource === 'object' && 'errors' in errorSource && errorSource.errors;
	const firstError: AGGError | null = Array.isArray(errors) ? errors[0] : null;

	return firstError ? new RelayAGGError(firstError) : null;
};
